import { AxiosResponse } from "axios";
import axiosDirect from 'axios';
import imageCompression from 'browser-image-compression';

// CẤU HÌNH UPLOAD (Có thể chỉnh sửa trực tiếp ở đây)
const COMPRESS_UPLOAD_API_URL = 'https://service-upload.991991.eu.cc';
const UPLOAD_MAX_SIZE_MB = 0.2; // Nén ảnh xuống dưới 1MB
const UPLOAD_IMAGE_QUALITY = 0.8; // Nén dung lượng (chất lượng ảnh từ 0 đến 1)
const UPLOAD_FOLDER = 'vinhomes365'; // Thư mục upload mặc định

export interface IFileUpload {
  url: string;
  fileName: string;
  [key: string]: any;
}

/**
 * Upload một hoặc nhiều file lên server
 * Hỗ trợ nén ảnh và chuyển đổi định dạng sang WebP tự động.
 * @param images - Mảng File cần upload
 * @returns Promise với dữ liệu file đã upload
 */
export const uploadFile = async (images: File[]): Promise<IFileUpload> => {
  try {
    const formData = new FormData();

    // Xử lý nén ảnh và chuyển đổi sang WebP song song
    const processedFiles = await Promise.all(
      images.map(async (file) => {
        // Chỉ nén và chuyển đổi nếu file là hình ảnh
        if (file.type.startsWith('image/')) {
          try {
            const options = {
              maxSizeMB: UPLOAD_MAX_SIZE_MB,
              maxWidthOrHeight: 1920, // Giới hạn chiều rộng/cao tối đa 1920px
              useWebWorker: true,
              fileType: 'image/webp',
              initialQuality: UPLOAD_IMAGE_QUALITY,
            };
            const compressedBlob = await imageCompression(file, options);

            // Lấy tên file gốc bỏ phần mở rộng và đổi sang .webp
            const originalNameWithoutExt = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
            return new File([compressedBlob], `${originalNameWithoutExt}.webp`, {
              type: 'image/webp',
              lastModified: Date.now()
            });
          } catch (compressionError) {
            console.error('Lỗi nén ảnh, sử dụng file gốc:', compressionError);
            return file;
          }
        }
        return file;
      })
    );

    for (let index = 0; index < processedFiles.length; index++) {
      formData.append('images[]', processedFiles[index]);
    }
    formData.append('folder', UPLOAD_FOLDER);

    const { data }: AxiosResponse<any> = await axiosDirect.post(
      `${COMPRESS_UPLOAD_API_URL}/upload.php`,
      formData
    );

    if (data && data.success && data.data && data.data.uploaded && data.data.uploaded.length > 0) {
      const firstFile = data.data.uploaded[0];
      return {
        url: firstFile.file_url,
        fileName: firstFile.file_name,
        ...firstFile
      };
    } else {
      const errorMsg = data?.message || (data?.data?.errors?.[0]?.error) || 'Lỗi tải tệp tin lên server';
      throw new Error(errorMsg);
    }
  } catch (error: any) {
    throw new Error(error.message || 'Lỗi tải tệp tin lên server');
  }
};